module.exports = __webpack_public_path__ + "img/gallery-1.561b1762.jpg";